import React from 'react';
import './Header.css';
import Login from '../Login/Login';

export default class Header extends React.Component {
  public render() {
    return (
      <div className="header">
        <div className="headerContent">
          <span className="logo"><img src="https://api.clarizen.com/V2.0/REST/images/clarizen-logo.png" alt="Clarizen" /></span>
          <h1 className="title">REST Metadata API Reference Guide</h1>
        </div>
        <Login />
      </div>
    );
  }
}
